import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Basta = lazy(() => import("@/pages/elbolag/Basta"));

export const Route = createFileRoute("/elbolag/basta")({
  head: () => seoHead("/elbolag/basta"),
  component: () => <Basta />,
});
